<template>
  <div class="page-container">
    <div id="searchArea">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList(1)">
        <div class="clearfix">
          <div class="fl pb10">
            <el-button :disabled="addBtnLoading" type="primary" @click="addOrUpdateHandle()">Add Template</el-button>
          </div>
          <div class="fr">
            <el-form-item>
              <el-input v-model="dataForm.keyword" clearable placeholder="Template Name" class="wd300"></el-input>
            </el-form-item>
            <el-form-item>
              <el-select v-model="dataForm.country" filterable clearable placeholder="Country">
                <el-option v-for="item in countryList" :key="item.value" :label="item.title" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="dataForm.supplierId" filterable clearable placeholder="Supplier">
                <el-option v-for="item in supplierList" :key="item.id" :label="item.companyName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" type="primary" plain v-debounce @click="getDataList(1)">Search</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <div>
      <el-table
        max-height="680"
        :data="dataList"
        v-loading="dataListLoading"
        @sort-change="tableSortChange"
        :default-sort="{ prop: 'createTime', order: 'descending' }"
        style="width: 100%"
      >
        <el-table-column prop="templateName" label="Template Name" align="center" min-width="250"></el-table-column>
        <el-table-column prop="country" label="Country" align="center" min-width="130"></el-table-column>
        <el-table-column prop="supplier.abbr" label="Supplier" align="center" min-width="100"></el-table-column>
        <el-table-column prop="invoiceType" label="Invoice Type" align="center" width="120">
          <template slot-scope="scope">
            <p>{{ invoiceTypeFormat(scope.row.invoiceType) }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="languageOption" label="Language" align="center" width="150" :formatter="languageOptionListFormat"></el-table-column>
        <el-table-column prop="bankAccountList" label="Bank Accounts" align="center" min-width="150" :formatter="bankAccountListFormat" />
        <el-table-column label="Create Time" prop="createTime" align="center" width="160" sortable="custom" />
        <el-table-column label="Action" align="center" width="120" fixed="right">
          <template slot-scope="scope">
            <!-- 修改 -->
            <el-button type="text" class="fwb" @click="addOrUpdateHandle(scope.row)">Edit</el-button>
            <!-- 删除 -->
            <el-button type="text" class="fwb" @click="deleteHandle(scope.row)">Delete</el-button>
            <!-- 预览 -->
            <el-button type="text" class="fwb" @click="previewHandle(scope.row)">Preview</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <pagination
      :current="current"
      :pageSize="pageSize"
      :totalCount="totalCount"
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
    ></pagination>

    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update
      ref="addOrUpdate"
      :supplierList="supplierList"
      :invoiceTemplateList="invoiceTemplateList"
      @refreshDataList="refreshDataList"
    ></add-or-update>
    <!-- 预览弹窗 -->
    <preview ref="preview"></preview>
  </div>
</template>

<script>
import AddOrUpdate from "./modal/AddOrUpdate";
import Preview from "./modal/Preview";
import Pagination from "@/components/Pagination";
import formatterMixin from "@/mixins/formatterMixin";
import paginationMixin from "@/mixins/paginationMixin";
import tableMixin from "@/mixins/tableMixin";
import { mapState } from "vuex";
export default {
  mixins: [formatterMixin, paginationMixin, tableMixin],
  components: {
    AddOrUpdate,
    Preview,
    Pagination,
  },
  data() {
    return {
      dataList: [],
      addBtnLoading: false,
      dataListLoading: false,
      dataForm: {
        keyword: "",
        country: "",
        supplierId: "",
        "orders[0].asc": false,
        "orders[0].column": "id",
      },
      supplierList: [],
      invoiceTemplateList: [],
    };
  },
  computed: {
    ...mapState("constant", ["countryList"]),
  },
  methods: {
    // 获取供应商列表
    getSupplierList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/supplier")
          .then(res => {
            this.supplierList = res.data || [];
            resolve();
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 获取发票模板列表
    getInvoiceTemplateList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/invoiceTemplate")
          .then(res => {
            this.invoiceTemplateList = res.data || [];
            resolve();
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 获取数据分页
    async getDataList(current) {
      this.dataListLoading = true;
      if (current) {
        this.current = current;
      }
      const params = {
        current: this.current,
        size: this.pageSize,
        ...this.dataForm,
      };
      const { code, data } = await this.$http.get("/admin/invoiceTemplate/page", {
        params,
      });
      if (code === 200) {
        this.dataList = data.records;
        this.totalCount = data.total;
      } else {
        this.dataList = [];
        this.totalCount = 0;
      }
      this.dataListLoading = false;
    },
    // 新增 / 修改
    addOrUpdateHandle(row) {
      this.$refs.addOrUpdate.init(row);
    },
    // 预览
    previewHandle(row) {
      this.$refs.preview.init(row.id);
    },
    // 删除
    async deleteHandle(row) {
      await this.$confirm(`Delete this template. Continue?`, "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      });
      const { code, msg } = await this.$http.delete(`/admin/invoiceTemplate`, {
        params: {
          "ids[]": row.id,
        },
      });
      if (code === 200) {
        this.$message({
          message: "success",
          type: "success",
          duration: 1500,
          onClose: () => {
            // mixins
            this.singleDataDelete();
            this.getInvoiceTemplateList();
            this.getDataList();
          },
        });
      } else {
        this.$message.error(msg);
      }
    },
    // 弹窗组件触发更新
    refreshDataList() {
      this.getInvoiceTemplateList();
      this.getDataList();
    },
  },
  async activated() {
    try {
      this.addBtnLoading = true;
      this.dataListLoading = true;
      await this.getSupplierList();
      await this.getInvoiceTemplateList();
    } catch (error) {
    } finally {
      this.getDataList();
      this.addBtnLoading = false;
    }
  },
};
</script>
